'use client';

import { ArrowLeft } from 'lucide-react';
import { HubNewsItem } from '@/types/hubs';
import IconAdaptive from '@/components/IconAdaptive';
import SearchResultCounter from '@/components/SearchResultCounter';
import HubNewsCopyUrlUnit from '@/(routers)/hubs/cases/components/unit/HubNewsCopyUrlUnit';

export interface HubNewsHubHeaderProps {
    hubNews: HubNewsItem;
    hubNewsCount: number;
    onBack?: () => void;
    copyUrl?: string;
}

const BUTTON_CLASS =
    'flex shrink-0 justify-center items-center gap-1.5 h-9 px-4 rounded-full border border-color-input-border bg-color-white-base text-color-co-gray-dark font-notojp font-bold text-xs hover:border-color-service-selected hover:text-color-service-selected transition-colors duration-150';

export default function HubNewsHubHeader({ hubNews, hubNewsCount, onBack, copyUrl }: HubNewsHubHeaderProps) {
    return (
        <div className="flex flex-col w-full">
            <div className="flex flex-col w-full gap-1.5">
                <span className="flex w-fit shrink-0 items-center h-5 px-3 rounded-3xl bg-color-base font-cantarell font-bold text-xs text-color-white-base uppercase">
                    {hubNews.hub_type}
                </span>
                <div className="flex items-center w-full gap-2">
                    <div className="flex flex-grow flex-wrap items-baseline gap-x-2 gap-y-1">
                        <span className="font-corp font-bold text-xl md:text-2xl text-color-base">
                            {hubNews.hub_name}
                        </span>
                        {hubNews.hub_sub_name && (
                            <span className="font-notojp font-medium text-xs text-color-co-gray-dark">
                                {hubNews.hub_sub_name}
                            </span>
                        )}
                    </div>
                    {copyUrl && (
                        <HubNewsCopyUrlUnit copyUrl={copyUrl} toastMessage="この事例ページのURLをコピーしました" />
                    )}
                </div>
            </div>

            <div className="flex flex-col md:flex-row md:items-center w-full gap-3 md:gap-4 pt-5 mt-4 border-t border-color-co-gray-light">
                {onBack && (
                    <div className="flex flex-wrap items-center w-full md:w-auto gap-2">
                        <button type="button" className={BUTTON_CLASS} onClick={onBack}>
                            <IconAdaptive Icon={ArrowLeft} strokeWidth={2.2} baseSize={14} breakpoints={{ md: 14 }} />
                            すべての事例に戻る
                        </button>
                    </div>
                )}
                <div className="flex justify-start md:justify-end w-full md:w-auto md:ml-auto md:shrink-0">
                    <SearchResultCounter prefixLabel="事例" suffixLabel="件" allCount={hubNewsCount} />
                </div>
            </div>
        </div>
    );
}
